import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { areEqual } from './areEqual';
import { WeekSelectionWrapper, DateTitleParagraph } from './styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// eslint-disable-next-line react/display-name
const WeekSelection = React.memo(({ selectedDays, handlePrevWeek, handleNextWeek }) => {
  const startDate = moment(selectedDays[0]);
  const endDate = moment(selectedDays[6]);
  const startMonth = startDate.format('MMM');
  const endMonth = endDate.format('MMM');

  return (
    <WeekSelectionWrapper>
      <span 
        role="button" 
        data-test="week-prev-btn"
        onClick={handlePrevWeek}
      >
        <FontAwesomeIcon icon="caret-left" />
      </span>
      <DateTitleParagraph data-test="selected-week">
        {`${startMonth}. ${startDate.format('D')} - ${endDate.format('D')}${(startMonth !== endMonth ? (' ' + endMonth) : '')}, ${endDate.format('YYYY')}`}
      </DateTitleParagraph>
      <span 
        role="button" 
        data-test="week-next-btn"
        onClick={handleNextWeek}
      >
        <FontAwesomeIcon icon="caret-right" />
      </span>
    </WeekSelectionWrapper>
  );
}, areEqual);

WeekSelection.propTypes = {
  handlePrevWeek: PropTypes.func.isRequired,
  handleNextWeek: PropTypes.func.isRequired,
  selectedDays: PropTypes.arrayOf(Date).isRequired,
};

export default WeekSelection;